module.exports = global.config = {
  host: "https://api-gateway.sampangkab.go.id/be-dispendukcapil",
  //subdomain: "dispendukcapil",
};
